import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SignaturePad } from 'angular2-signaturepad';
import { ApiService } from 'src/app/services/api.service';
import { SignatureService } from 'src/app/services/signature.service';
@Component({
  selector: 'app-signature',
  templateUrl: './signature.component.html',
  styleUrls: ['./signature.component.scss']
})
export class SignatureComponent implements OnInit {

  @ViewChild(SignaturePad,{static:true}) signaturePad: SignaturePad;
  activated;

  signaturePadOptions: Object = { 
    'minWidth': 5,
    'canvasWidth': window.innerWidth-10,
    'canvasHeight': 200,
  };
  signature_data;

  constructor(private api: ApiService,private signatureService: SignatureService,private router: Router) {}
  ngOnInit() {
    if(sessionStorage.getItem('SIGNATURE_ID')==null){
      this.router.navigateByUrl("/qrcode")
    }
    this.signatureService.connect(); 
    this.signatureService.socket().subscribe((res)=>{
      try{
        let data=JSON.parse(res)
        console.log(">>>",data)
        if(data.status=='activate')
        {
          this.activated=true;
        }
      }catch(error){

      }
    });
  }
  

  ngAfterViewInit() {
   
    this.signaturePad.set('minWidth', 5);
    this.signaturePad.clear(); 
  }

  drawComplete() {
    this.signature_data=this.signaturePad.toDataURL();
  }

  drawStart() {
 
    console.log('begin drawing');
  }

  clear(){
    this.signaturePad.clear(); 
  }
  submit(){
    let id=localStorage.getItem("id");
    let data={
      id:id,
      signature:this.signature_data
    }
  // this.api.postSignature(data).subscribe((res)=>{

  // },(err)=>{});
    this.signatureService.send(data);
    this.signaturePad.clear(); 
    this.activated=false;
    // this.api.message = "";
  }
  exit(){
    sessionStorage.clear()
    localStorage.clear()
    this.router.navigateByUrl("/")
    
  }
}
